/**
 * Общие селекторы для форм Contact Form 7
 * @constant {Object} FORM_SELECTORS
 */
export const FORM_SELECTORS = {
  FORM: '.wpcf7',
  SUBMIT_BUTTON: '.wpcf7-submit',
  PHONE_INPUT: '[name="your-phone"]',
  ACCEPTANCE_CHECKBOX: '.custom-checkbox__input',
};

/**
 * CSS классы для форм
 * @constant {Object} FORM_CLASSES
 */
export const FORM_CLASSES = {
  FORM: 'wpcf7',
  RESPONSE_SUCCESS: 'response-success',
  RESPONSE_FAIL: 'response-fail',
  RESPONSE_ACTIVE: 'response--active',
  RESPONSE_BUTTON: 'response__button',
};

/**
 * CSS классы для модальных окон
 * @constant {Object} MODAL_CLASSES
 */
export const MODAL_CLASSES = {
  OVERLAY: {
    ACTIVE: 'bg-overlay--active',
    CLOSE: 'bg-overlay__close',
    CLOSE_ACTIVE: 'bg-overlay__close--active',
  },
  FORM: {
    ACTIVE: 'request-form--active',
  },
};

/**
 * Маппинг языка на ID контейнера формы
 * @constant {Object} FORM_LANG_MAP
 */
export const FORM_LANG_MAP = {
  ru: '#request-form',
  kk: '#request-form-kz',
};

/**
 * Константы для валидации
 * @constant {Object} VALIDATION_CONSTANTS
 */
export const VALIDATION_CONSTANTS = {
  PHONE_LENGTH: 11,
};